import {getUUID, IBridgeRequest, IBridgeResponse, RequestFunction} from "./android-bridge";

class IosBridge {
    callLog: { [key: string]: Function } = {};
    private static instance: IosBridge;

    static getInstance() {
        if (!IosBridge.instance) {
            IosBridge.instance = new IosBridge()
        }
        return IosBridge.instance;
    }

    constructor() {
        if (!window.payments) {
            window.payments = {};
        }
        window.payments.handleCallback = (data: IBridgeResponse) => this.handleCallback(data);
        window.payments.triggerEventFromWeb = (eventName: string, eventProperties: any) => this.triggerEventFromWeb(eventName, eventProperties)
    }

    handleCallback = (data: IBridgeResponse) => {
        console.log(data, 'ios Response from bridge')
        if (data.requestId && typeof this.callLog[data.requestId] == 'function') {
            this.callLog[data.requestId](data.response);
        } else {
            // console.log(data.requestId);
        }
    };

    callBridge = (requestFunction: RequestFunction, params: any[], callback: Function) => {
        const request: IBridgeRequest = {
            requestId: getUUID(),
            callbackFunction: 'window.payments.handleCallback',
            params: params,
            requestFunction: requestFunction,
        };
        this.callLog[request.requestId] = callback;
        console.log(request)
        window.ios.handleRequest(JSON.stringify(request));
    };

    processQuery = (
        requestFunction: RequestFunction,
        params: any[]
    ): Promise<any> => {
        return new Promise((resolve, reject) => {
            try {
                this.callBridge(requestFunction, params, (res: any) => {
                    resolve(res);
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    execute = async (
        requestFunction: RequestFunction,
        params: any[],
        //@ts-ignore
        tryCount?: number = 3
    ): Promise<any> => {
        try {
            let res: any = await this.processQuery(requestFunction, params);
            if (res.status !== 'SUCCESS' && tryCount > 1) {
                // await Utils.sleep(1000);
                return await this.execute(requestFunction, params, --tryCount);
            }
            return res;
        } catch (e) {
            if (tryCount >= 1) {
                // await Utils.sleep(1000);
                return await this.execute(requestFunction, params, --tryCount);
            } else {
                // captureException(e as Error);
                throw e;
            }
        }
    };

    triggerEventFromWeb = (eventName: string, eventProperties: any) => {
        if (eventName === 'USER_PROPERTIES' && eventProperties.user_id) {
            window.rudderanalytics.identify(eventProperties.user_id, eventProperties);
        } else {
            // analytics.loanEventFromBridge({eventName:eventName as any, eventProperties})
        }
    }
}

export default IosBridge;
